import React from 'react'
import { Button, Header, Icon, Modal, Segment, Form, Comment} from 'semantic-ui-react'
import ManageExamenRespuestas from '../examen/ManageExamenRespuestas'

const ModalExamen = ({comentarios=[],showModal, closeModal, icono, texto, titulo,quiz }) => (
    
    
  <Modal open={showModal}  size='large' >
  <Segment >
    
     <Modal.Content scrolling>
        
    
        {quiz!=null?
             <div>
                    <Header as='h3'>Respuestas del alumno, examen realizado el: {quiz.creadoEl} </Header>

                        {quiz.questions.map(preguntas=>
                            <Segment attached>
                            <Header size='medium'>
                                {preguntas.question}
                            </Header>
                            <Segment.Group compact>
                            {preguntas.answers.map((respuesta, i) =>

                                <>

                                {preguntas.correctAnswer.length==1?
                        
                                    <Segment >

                                        {respuesta}  - 
                                            {preguntas.userInput==i+1?
                                                <Icon name="user" color={preguntas.correctAnswer==i+1?"green":"red"}/> 
                                                :
                                                ""
                                            }

                                            {preguntas.correctAnswer==i+1?
                                                <Icon name="checkmark" color="green"/>    
                                            :

                                                ""
                                            }

                                        
                                    </Segment>
                                
                                :
                                    <Segment>
                                        {respuesta}  - 
                                        {preguntas.correctAnswer.map((respuestaCorrecta, j) =>
                                         
                                            <>  
                                                {i+1==Number(respuestaCorrecta)?
                                         
                                                     <Icon name="checkmark" color="green"/>
                                                    :
                                                    ""           
                                            
                                                }
                                    
                                                 {preguntas.userInput[j]==i+1?
                                                    <Icon name="user" color={i+1==Number(respuestaCorrecta)?"green":"red"}>
                                                        
                                                    </Icon>    
                                                    :
                                                    ""
                                                }
                                        
                                            </>
                                        )}
                                    
                                    </Segment>
                                }
                                </>    

                            )}
                            </Segment.Group>

                         </Segment>

                        )}
            </div>                        
        :

            "Cargando"

        }
    
    
        
    
        
    </Modal.Content>

  

    
    
 
     <Modal.Actions>
        <Button  color='red' onClick={()=>closeModal(0)}>
            <Icon name='remove' /> Cerrar
        </Button>
      </Modal.Actions>
 </Segment>      
</Modal>
    
    
 
   
)

export default ModalExamen